import "./main";
import "./home.css";
import "./product.css";
import { enhanceDownloadLinks } from "./store-links";

enhanceDownloadLinks(document, navigator);
